// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8a2b333e","513":"10a12faa","703":"05fc9814","787":"453e342c"}[chunkId] + ".chunk.js";
};